export const defaultContentMapperXlsx = (item: Record<string, any>) => {
  const obj: Record<string, any> = {} as any;

  Object.keys(item).forEach((key) => {
    obj[key] = item[key] ?? "";
  });

  return obj;
};
